/**
 * Makes a copy of an object by transforming it into a string and backwards.
 * In case of error returns the original object
 */
const deepClone = <T = Record<string, unknown>>(v: T): T => {
  try {
    const str = JSON.stringify(v);
    return JSON.parse(str);
  } catch (e) {
    console.error(e);
    return v;
  }
};

export default deepClone;
